import {PromocodeDto, PromocodeRs} from "@/types/promocodes";

//Mapping from collection of PromocodeRs to collection of PromocodeDto
export function mapToPromocodeDto(from: PromocodeRs[]): PromocodeDto[] {
    return from.map(promocode => ({
        id: promocode.id,
        promocode: promocode.promocode,
        specialistId: promocode.specialistId,
        description: promocode.description,
        discountPercentage: promocode.discountPercentage * 100,
        discountAmount: promocode.discountAmount,
        validUntil: promocode.validUntil ? new Date(promocode.validUntil).toLocaleDateString() : null,
        validAmount: promocode.validAmount,
        usedAmount: promocode.usedAmount,
        createdAt: new Date(promocode.createdAt)
    }))
}
